<template>
  <div class="field is-grouped is-grouped-multiline">
    <file-tag
      v-for="(file, index) in files.slice(0, max_tags)"
      :key="index"
      :filename="filename(file)"
      :filetype="fileType(file)"
      :fileOwner="file.file_owner === true"
      @DOWNLOAD_FILE="download(file)"
      @DELETE_FILE="deleteFile(file)"
    ></file-tag>
    <template v-if="files.length > max_tags">
      <br />
      <span>+ {{ notShownFilesCount }} filer ikke vist</span>
    </template>
  </div>
</template>

<script>
import FileTag from '@/infrastructure/fileuploads/components/FileTag'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FileTagsList',
  components: {
    FileTag
  },
  props: ['files', 'max_tags'],
  computed: {
    ...mapGetters('fileuploads', ['originalFilename', 'isLoading']),
    notShownFilesCount () {
      return this.files.length - this.max_tags
    }
  },
  methods: {
    ...mapActions('fileuploads', [
      'downloadFile',
      'setOriginalFilename',
      'removeFile',
      'setIsLoading'
    ]),
    deleteFile (file) {
      if (window.confirm('Do you really want to delete?')) {//eslint-disable-line
        this.setIsLoading(true)
        this.removeFile(file.id)
          .then(() => {
            this.setIsLoading(false)
            this.$buefy.toast.open({
              message: `Filen er blevet slettet`,
              type: 'is-success',
              duration: 5000
            })
          })
          .catch(() => {
            this.setIsLoading(false)
            this.$buefy.toast.open({
              message: `Filen kunne ikke slettes. Prøv igen senere`,
              type: 'is-danger',
              duration: 5000
            })
          })
      }
    },
    download (file) {
      this.setIsLoading(true)

      this.setOriginalFilename(file.original_filename)
      this.downloadFile(file.id)
        .then(() => {
          this.setIsLoading(false)
        })
        .catch(() => {
          this.setIsLoading(false)
        })
    },
    fileType (file) {
      const lIO = file.original_filename.lastIndexOf('.')
      if (lIO === -1) {
        return ''
      }
      return file.original_filename.split('.').pop()
    },
    filename (file) {
      return file.original_filename
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/infrastructure/fileuploads/components/FileTagsList.vue